export default __webpack_public_path__ + "images/checkmark-cb6032192e3f28c241a73d1bbda36778.svg";